var state = {
  imageLogPropertyJSON: [],
  selectedImageLogProperty: "RHOB",
  // "Amplitude" for Troll, & "RHOB" for Gina Krog
  // Note: the setting of defaultSelectedCurtainProperties loaded from GK-new-4/decisions.json/defaultSelectedCurtainProperties will overwrite this.
  selectedCurtainProperties: ["BG", "SynRes_2Rx", "SynRes_3Rx"],
  //["DT", "Flag", "RT_new", "RHOB", "GR", "VSH", "PHIT"], // "Amplitude" for Troll, & "DT" for Gina Krog
  trimImageLog: true,
  diameterImageLog: 0.31,
  // Available diameters for GinaKrog Model: 0.31, 1, 2, 5, 10 meter
  geometryForVtk: null,
  textureForVtk: null
};
var getters = {};
var actions = {};
var mutations = {
  updateSelectedCurtainProperties: function updateSelectedCurtainProperties(state, value) {
    state.selectedCurtainProperties = value;
  },
  updateImageLogPropertyJSON: function updateImageLogPropertyJSON(state, value) {
    state.imageLogPropertyJSON = value;
  },
  updateSelectedImageLogProperty: function updateSelectedImageLogProperty(state, value) {
    state.selectedImageLogProperty = value;
  },
  updateTrimImageLog: function updateTrimImageLog(state, value) {
    state.trimImageLog = value;
  },
  updateGeometryForVtk: function updateGeometryForVtk(state, value) {
    state.geometryForVtk = value;
  },
  updateTextureForVtk: function updateTextureForVtk(state, value) {
    state.textureForVtk = value;
  }
};
export default {
  namespaced: true,
  state: state,
  getters: getters,
  actions: actions,
  mutations: mutations
};